<template>
  <layout-pondlogs container-type="card-footer" class="reports">
    <template slot="title">
      <div style="display:flex;align-items: center;">
        <i class="material-icons-round">pie_chart</i>

        <div>{{ $t("Comn_reports") }}</div>
      </div>
    </template>

    <template slot="header">
      <el-row>
        <el-col :span="5" class="header__style">
          <er-date-picker
            v-model="value1"
            value-format="yyyy-MM-dd"
            :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></er-date-picker>
        </el-col>
      </el-row>
    </template>
    <template slot="pondlogs-default-layout-main">
      <el-row type="flex" justify="space-between">
        <el-col :span="16" class="pond-container">
          <div>
            <div class="header">{{ $t("Comn_ponds") }}</div>
            <div v-loading="loading">
              <el-checkbox
                v-model="checkAllPonds"
                @change="handleCheckAllPonds"
              >
                <span class="title">All</span>
              </el-checkbox>
              <div style="margin: 15px 0;"></div>

              <el-checkbox-group
                v-model="pondList"
                style=" display: grid;
    grid-template-columns: auto auto auto;  grid-gap: 10px;"
              >
                <el-checkbox
                  v-for="pond in allPondsofUser"
                  :label="pond._id"
                  :key="pond._id"
                >
                  <span class="title">{{ pond.title }}</span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-col>

        <el-divider direction="vertical"></el-divider>

        <el-col :span="8" class="report-container">
          <div>
            <div class="header">{{ $t("Reports_report_type") }}</div>
            <el-checkbox
              v-model="checkAllReports"
              @change="handleCheckAllReport"
            >
              <span class="title">All</span>
            </el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group
              v-model="checkList"
              style="display:grid;  grid-gap: 10px;"
            >
              <el-checkbox
                v-for="pond in allPondsInformationList"
                :label="pond.id"
                :key="pond.id"
              >
                <span class="title">{{ pond.title }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-col>
      </el-row>
      <el-divider direction="horizontal"></el-divider>
    </template>
    <template slot="card-footer">
      <el-col :span="24">
        <div class="footer-container">
          <div class="info__container">
            <i class="material-icons-outlined">info</i>

            <p class="content">{{ $t("Comn_reports_footer") }}</p>
          </div>

          <div class="download__container">
            <div class="gap__between__download__send">
              <er-button
                btnType="download"
                @click="download"
                :showLabel="true"
                :showIcon="true"
              >
                {{ $t("Comn_download_report") }}
              </er-button>
            </div>

            <div class="email-section">
              <div @click="sendemail" class="email__container">
                <span class="email__icon">
                  <img src="@/assets/email.svg" />
                </span>
                <span class="email__content">{{ $t("Comn_send_email") }}</span>
              </div>
              <!--
              <er-button @click="sendemail" btnType="email" :showLabel="true" :showIcon="true"></er-button>-->
            </div>
          </div>
        </div>
      </el-col>
    </template>
  </layout-pondlogs>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import userService from "./../../services/userService";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import moment from "moment";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";
export default {
  mixins: [errorHandlerMixin],
  data() {
    return {
      checkList: [],
      pondList: [],
      value1: "",
      loading: false,
      checkAllReports: false,
      checkAllPonds: false,
      reportListData: [
        "POND_GUARD_DATA",
        "POND_MOTHER_DATA",
        "HOURLY_FEED_DATA",
        "MANUAL_FEED_DATA",
        "WATER_QUALITY_TEST_DATA",
        "MEDICINES_MINERALS_DATA",
        "YIELD_DATA",
        "ABW_DATA"
      ],
      pondListData: []
    };
  },
  computed: {
    ...mapGetters("pond", {
      getPonds: "getPonds"
    }),
    ...mapGetters("user", {
      getCurrUserLocation: "getCurrUserLocation"
    }),
    allPondsofUser() {
      return this.$lodash
        .cloneDeep(this.getPonds)
        .sort((a, b) =>
          this.$commonUtils.alphaNumericComparator(a.title, b.title)
        );
    },
    allPondsInformationList() {
      this.pondListData = this.getPonds.map(x => x._id);
      return [
        { title: "Pond Guard", id: "POND_GUARD_DATA" },
        { title: "Pond Mother", id: "POND_MOTHER_DATA" },
        { title: this.$t("Comn_hourly_feed"), id: "HOURLY_FEED_DATA" },
        { title: this.$t("Comn_manual_feed"), id: "MANUAL_FEED_DATA" },
        { title: "ABW", id: "ABW_DATA" },
        {
          title: this.$t("Reports_water_quality_test"),
          id: "WATER_QUALITY_TEST_DATA"
        },
        {
          title: this.$t("Comn_medicines_and_minerals"),
          id: "MEDICINES_MINERALS_DATA"
        },
        { title: this.$t("Comn_yield"), id: "YIELD_DATA" }
      ];
    }
  },

  async mounted() {
    this.value1 = [
      this.$moment()
        .subtract(1, "week")
        .format("YYYY-MM-DD"),
      this.$moment().format("YYYY-MM-DD")
    ];
    await this.initComponent();
  },
  methods: {
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds"
    }),

    downloadkeys() {
      var object = {
        ponderrormessage: this.$t("Comn_report_pond_error"),
        reporterrormessage: this.$t("Comn_report_report_error"),
        downloaderrormessage: this.$t("Comn_download_error")
      };
      if (this.checkList.length == 0 && this.pondList.length == 0) {
        return object.downloaderrormessage;
      } else {
        return this.pondList.length
          ? object.reporterrormessage
          : object.ponderrormessage;
      }
    },
    emailkeys() {
      var object = {
        ponderrormessage: this.$t("Comn_pond_email_error"),
        reporterrormessage: this.$t("Comn_report_email_error"),
        downloaderrormessage: this.$t("Comn_email_error")
      };
      if (this.checkList.length === 0 && this.pondList.length === 0) {
        return object.downloaderrormessage;
      } else {
        return this.pondList.length
          ? object.reporterrormessage
          : object.ponderrormessage;
      }
    },
    async initComponent() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchAllPonds({
            location_id: this.getCurrUserLocation._id,
            status: ["ACTIVE", "INACTIVE"],
            include: ["title", "status"],
            get_all: true
          })
        ]);
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },

    download: async function() {
      try {
        this.isHighPriorityUsersRestricted();
        if (!this.pondList.length || !this.checkList.length) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                type: "number",
                required: true,
                message: this.downloadkeys(),
                trigger: "blur"
              }
            ]
          };
        }
        const response = await userService.fetchZipReportsData({
          pond_ids: this.pondList,
          params: this.checkList,
          from_time: moment(this.value1[0]).format("YYYY-MM-DD"),
          to_time: moment(this.value1[1]).format("YYYY-MM-DD"),
          responseType: "blob"
        });
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/zip" })
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Eruvaka.zip");
        document.body.appendChild(fileLink);
        fileLink.click();
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    sendemail() {
      try {
        this.isHighPriorityUsersRestricted();
        throw {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: "Under Development"
            }
          ]
        };
      } catch (error) {
        this.errorMessages(error, true);
      }
    },
    handleCheckAllReport(val) {
      this.checkList = val ? this.reportListData : [];
    },
    handleCheckAllPonds(val) {
      this.pondList = val ? this.pondListData : [];
    }
  }
};
</script>

<style lang="scss">
.reports {
  .header__style {
    float: right;
  }
  .pond-container {
    @include responsiveProperty(height, 73vh, 77vh, 80vh);
    overflow-y: scroll;

    .header {
      font-weight: 600;
      line-height: 2;
      margin-top: 15px;
      margin-bottom: 15px;
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
    .title {
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
  }

  .report-container {
    padding-left: 30px;
    .header {
      font-weight: 600;
      line-height: 2;
      margin-top: 15px;
      margin-bottom: 15px;
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
    .title {
      @include responsiveProperty(
        font-size,
        $app_font_size_1,
        $app_font_size_2,
        $app_font_size_3
      );
    }
  }
  .footer-container {
    display: flex;
    justify-content: space-between;
    .info__container {
      display: flex;
      align-items: center;
      .content {
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
        margin-left: 10px;
      }
    }
    .download__container {
      display: flex;
      .material-icons-round {
        color: #ffffff;
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
      }
      .gap__between__download__send {
        margin-right: 10px;
      }
    }

    .email-section {
      .email__container {
        border-radius: 4px;
        background-color: green;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .email__icon {
        display: flex;
        padding-left: 10px;
      }
      .email__content {
        @include responsiveProperty(
          font-size,
          $app_font_size_1,
          $app_font_size_2,
          $app_font_size_3
        );
        color: white;
        padding: 7px 15px 7px 5px;
      }
    }
  }

  .material-icons-round {
    color: #1966a1;
    margin-right: 15px;
  }

  .material-icons-outlined {
    @include responsiveProperty(
      font-size,
      $app_font_size_2,
      $app_font_size_3,
      $app_font_size_xl
    );
  }
  .el-divider--vertical {
    @include responsiveProperty(height, 73vh, 77vh, 80vh);
  }
  .el-divider--horizontal {
    margin: 0;
  }
}
</style>